module.exports = "/desktop-app/assets/img/credit-card.png?d2ee2633a8d7c8553a90f44e7fdf4a79";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/static/icons/credit-card.png
// module id = wBAB
// module chunks = 1